import React ,{useState, useEffect} from 'react';


import '../components/styles/navbar.css';
import '../components/styles/service.css';
import '../components/styles/hero.css';
import '../components/styles/footer.css'
import '../components/styles/global.css';


import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const HomeScreenPage: React.FC = () => {

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const section = document.querySelector(location.hash);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location]);

  const handleClickScroll = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };


  return (
    // <>
    //   <Navbar />
    //   <Hero />
    //   <Services />
    //   <Footer />
    // </>
    <div className="home-page">
    <header className="navbar">
      <div className="navbar-logo">Qualak</div>
      <nav className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
        <ul>
          {/* <li><a href="/AboutUs">About</a></li> */}
          <li><Link to="/about-us">About Us</Link></li>
          {/* <li><a href="#careers">Careers</a></li> */}
          {/* <li><a href="#news">News</a></li> */}
          <li>
              <a
                href="#contact"
                onClick={() => handleClickScroll('#contact')}
              >
                Contact
              </a>
            </li>
        </ul>
      </nav>
      <div className={`hamburger ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
    </header>

    <section className="hero" id="hero">
      <div className="hero-content">
      <video className="hero-video" autoPlay loop muted>
        <source src="/videos/VideoClip.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
        <h1>Welcome to Qualak</h1>
        <p>Shaping the future with cutting-edge analytics and transformative data solutions for smarter business decisions.</p>
        {/* <a href="#service" className="hero-btn">Learn More</a> */}
        <a
            href="#services"
            className="hero-btn"
            onClick={() => handleClickScroll('#services')}
          >
            Learn More
          </a>
      </div>
    </section>

<section className="services" id ="services">
<h2 className="services-title">Our Services</h2>
<div className="service-cards">
  {/* Card 1 */}
  <div className="service-card">
  <img src="/images/image1.svg" alt="Advanced Data Analytics" className="service-image"/>
    <div className="service-text">
      <h3>Advanced Data Analytics</h3>
      <p>
        Unlock the power of your data with cutting-edge analytics
        solutions. We transform raw data into actionable insights using
        advanced algorithms, ensuring you make informed, data-driven
        decisions that propel your business forward.
      </p>
    </div>
  </div>
  {/* Card 2 */}
  <div className="service-card-reverse">
    <div className="service-text">
      <h3>Predictive Modeling & Forecasting</h3>
      <p>
        Stay ahead of the competition with our predictive modeling
        services. Using state-of-the-art machine learning techniques, we
        forecast trends, behaviors, and outcomes, enabling strategic
        planning and proactive decision-making.
      </p>
    </div>
    <img src="/images/image2.svg" alt="Predictive Modeling & Forecasting" className="service-image"/>
  </div>

  {/* Card 3 */}
  <div className="service-card">
  <img src="/images/image3.svg" alt="Interactive Data Visualization" className="service-image"/>
    <div className="service-text">
      <h3>Interactive Data Visualization</h3>
      <p>
        Bring your data to life with compelling visualizations that tell a
        story. Our interactive dashboards and customized reports simplify
        complex information, empowering stakeholders to understand and
        act with clarity.
      </p>
    </div>
  </div>

  {/* Card 4 */}
  <div className="service-card-reverse">
    <div className="service-text">
      <h3>Data Strategy & Consulting</h3>
      <p>
        Develop a robust data strategy with the guidance of our expert
        consultants. We help you design tailored solutions for data
        collection, processing, and management to optimize efficiency and
        drive sustainable growth.
      </p>
    </div>
    <img src="/images/image4.svg" alt="Advanced Data Analytics" className="service-image"/>
  </div>
</div>
</section>
  
<div className="footer" id = "contact">
      {/* Top Row: Contact Us and Links */}
      <div className="footer-top">
        <div className="footer-left">
          <h2>Contact Us</h2>
          <p>Email: <a href="mailto:burak@qualak.com" className="email-link">burak@qualak.com</a></p>
        </div>
        <div className="footer-right">
          <div className="quick-links">
            {/* <a href="https://twitter.com/qualak" target="_blank" rel="noopener noreferrer">Twitter </a>
            <a href="https://linkedin.com/company/qualak" target="_blank" rel="noopener noreferrer">LinkedIn </a>
            <a href="https://github.com/qualak" target="_blank" rel="noopener noreferrer">GitHub </a> */}
            <a href="/about-us">About Us</a>  
            <a
                href="#services"
                onClick={() => handleClickScroll('#services')}
              >
                Services
              </a>
             <a
                href="#contact"
                onClick={() => handleClickScroll('#contact')}
              >
                Contact
              </a>
          </div>
        </div>
      </div>

      {/* Bottom Row: Footer Bottom Text */}
      <div className="footer-bottom">
        <div className='social-links'>
          <a href="https://x.com/qualak_official" target="_blank" rel="noopener noreferrer"> X </a> | 
          <a href="https://www.linkedin.com/company/qualak/about/" target="_blank" rel="noopener noreferrer"> LinkedIn </a>
          </div>

        <p>&copy; 2024 Qualak OÜ. All rights reserved.</p>
      </div>
    </div>
</div>
  );
};

export default HomeScreenPage;
